import TransLogTabs from "../components/TransLogTabs";
import TransLogTables from "../components/TransLogTables";
import { toRefs } from "vue";
export default {
  name: "Finished",
  components: {
    TransLogTabs,
    TransLogTables
  },
  setup() {
    const data = {
      columns: [{
        label: '文件名称',
        prop: 'fileName'
      }, {
        label: '需求名称',
        prop: 'demandName'
      }, {
        label: '文件大小',
        prop: 'handleSize'
      }, {
        label: '完成时间',
        prop: 'finishedTime'
      }],
      actionType: '3'
    };
    return {
      ...toRefs(data)
    };
  }
};